<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="dd-view-page-title" class="mb-3">
              {{ dataDiscovery.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('data_discovery')">
                <GuideButton :guide="getGuide('data_discovery')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-dd-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.DATA_DISCOVERY_EDIT, permissions.DATA_DISCOVERY_EDIT_OWN], dataDiscovery.created_by) && (!getClient.parent || (getClient.parent && dataDiscovery.partition))"
                      class="btn btn-edit"
                      qid="edit-dd-button"
                      @click="showEditDDModal(dataDiscovery)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.DATA_DISCOVERY_DELETE, permissions.DATA_DISCOVERY_DELETE_OWN], dataDiscovery.created_by) && (!getClient.parent || (getClient.parent && dataDiscovery.partition))"
                      class="btn btn-delete"
                      qid="delete-dd-button"
                      @click="showConfirmDeleteModal(dataDiscovery)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-dd-modified-date">
              {{ dataDiscovery.updated_at | formatDate }}
            </span>
              <Avatar v-if="dataDiscovery.updated_by"
                      :object="dataDiscovery.updated_by"
                      size="xs"
                      class="ml-3 mr-2"
              ></Avatar>
              <span v-if="dataDiscovery.updated_by" qid="view-dd-modified-by">
              {{ dataDiscovery.updated_by.name }}
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- First tab -->
      <b-tab :title="$t('maintenance.data_discovery.tab.basic_info')" active>
        <div class="card">
          <div class="card-body">
            <div class="content-view-body">
              <br>
              <div class="mt-3">
                <p class="text-dark">
                  {{ $t('maintenance.data_discovery.table.data_scanning') }}
                </p>
                <hr>
                <p>
                  <span v-if="dataDiscovery.data_scanning == 1" qid="dd-data-scanning-yes">
                    {{ $t('system.yes') }}
                  </span>
                  <span v-if="dataDiscovery.data_scanning == 0" qid="dd-data-scanning-no">
                    {{ $t('system.no') }}
                  </span>
                </p>
                <br>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <!-- Second tab -->
      <b-tab :title="$t('maintenance.data_discovery.tab.linked_systems')" class="mt-3">
        <SystemsTable :object="dataDiscovery"></SystemsTable>
      </b-tab>
    </b-tabs>


    <!-- Edit data discovery modal template -->
    <b-modal ref="edit-data-discovery" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-dd-title">
          {{ $t('maintenance.data_discovery.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-dd-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editDDFormSubmit" qid="create-dd-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-dd-name-label">
              {{ $t('maintenance.data_discovery.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-dd-form-name"
              type="text"
              v-model="ddForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.data_discovery.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-dd-data-scanning-label">
              {{ $t('maintenance.data_discovery.create.data_scanning_label') }}
            </label>
            <b-form-radio-group
              v-model="ddForm.data_scanning"
              :options="radioOptions"
              qid="edit-dd-form-data-scanning"
            ></b-form-radio-group>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditDDModal"
                    qid="edit-dd-cancel-button"
          >
            {{ $t('maintenance.data_discovery.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-dd-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.data_discovery.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete information obligation confirm modal template -->
    <b-modal ref="delete-data-discovery" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-dd-title">
          {{ $t('maintenance.data_discovery.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.data_discovery.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.data_discovery.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-dd-cancel-button"
        >
          {{ $t('maintenance.data_discovery.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteDD(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-dd-submit-button"
                  v-if="isGranted([permissions.DATA_DISCOVERY_DELETE, permissions.DATA_DISCOVERY_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.data_discovery.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {initialsAvatarUrl} from '@/util/userAvatar.js';
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import SystemsTable from '@/views/DataDiscovery/SystemsTable.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'DataDiscoveryView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.data_discovery.title'),
          to: '/maintenance/data-discovery'
        }
      ],
      dataDiscovery: {},
      itemToDelete: {},
      ddForm: {
        name: '',
        data_scanning: '',
        client:'',
      },
      error: '',
      radioOptions: [
        {text: this.$t('system.yes'), value: 1},
        {text: this.$t('system.no'), value: 0}
      ],
      buttonDisabled: false,
      myGuides: [],
    }
  },
  computed: {
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      }
    }
  },
  components: {
    Avatar,
    SystemsTable,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/data-discovery')
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance'
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    loadContent() {
      let self = this;
      piincHttp.get('data-discoveries/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.dataDiscovery = response.data;
        // Push Information obligation name in breadcrumb array
        self.breadcrumbItems.push({text: self.dataDiscovery.name, active: true});
      }, function() {});
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return initialsAvatarUrl(user);
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-data-discovery'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-data-discovery'].hide()
    },
    confirmDeleteDD(object) {
      let self = this;
      piincHttp.delete('data-discoveries/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.data_discovery.delete.success'))
      }, function() {});
    },
    showEditDDModal(object) {
      this.ddForm.slug = object.slug;
      this.ddForm.name = object.name;
      this.ddForm.data_scanning = object.data_scanning;
      this.$refs['edit-data-discovery'].show()
    },
    hideEditDDModal() {
      this.$refs['edit-data-discovery'].hide()
    },
    editDDFormSubmit(evt) {
      this.buttonDisabled = true;
      var moment = require('moment');
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.ddForm.client = this.getClient.slug;

      piincHttp.put('data-discoveries/' + this.ddForm.slug, this.ddForm).then(function(response) {
        self.hideEditDDModal();
        self.buttonDisabled = false;
        // If slug is not changed, just reload content
        if (response.data.slug === self.dataDiscovery.slug) {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.loadContent();
        } else {
          // If slug changed, reload state with new param
          self.$router.push({ name: 'maintenance.data_discovery.view', params: { slug: response.data.slug }})
        }
        self.$toastr('success', self.$t('maintenance.data_discovery.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    }
  },
  created () {
    this.loadContent()
    this.loadGuides('data_discovery');
  }
}
</script>
